module.exports = __webpack_public_path__ + "static/media/aika.e31988ef.jpg";